import { Component, OnInit } from '@angular/core';
import { AlertDataService } from './alert-data.service';
import { isEmptyObject } from 'jquery';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  alertsList:any = [{key : 'All Alerts' ,value : 'ALL' },{key : 'Yesterday',value : 'ACTUAL_DAILY'},{key : 'Real Time',value : 'ACTUAL_HOURLY'},{key : 'Nowcast',value : 'NOWCAST'},{key : 'Forecast',value : 'FORECAST'}]
  selectedAlert:any  ='ALL'
  selectedLocation:any = 'Andhra Pradesh'
  isInitialLoad: boolean = false
  viewToggle:boolean = false
  selectedParams: any = {};
  view: any = 'Forecast';
  selectedSource:any = 'ECMWF';
  sourceList:any = [{key : 'IMD' ,value : 'IMD_LONG_RANGE' },{key : 'ECMWF' ,value : 'ECMWF' }]
  constructor(private alertDataSrv: AlertDataService) { }

  ngOnInit() {
    this.isInitialLoad = true
    this.subscribeEvents();
  }

  subscribeEvents() {
    this.alertDataSrv.getSelectedParams().subscribe(params => {
      if(Object.keys(params).length > 0) {
        this.selectedParams = params
      } else {
        this.setSelectedParams();
      }
    })
  }

  onAlertSelect() {
    this.selectedParams['alertType'] = this.selectedAlert;
    this.selectedParams['actionType'] = 'filter'
    this.setSelectedParams()
  }

  onViewToggle() {
    if(this.viewToggle) {
      this.selectedParams['view'] = 'Observed'
    } else {
      this.selectedParams['view'] = 'Forecast'
    }
    this.setSelectedParams();
  }

  setSelectedParams() {
    let currentUrlParams = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.selectedParams;
    }
    if(this.isInitialLoad) {
      currentUrlParams['location'] = this.selectedLocation;
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['component'] = 'RAINFALL';
      currentUrlParams['dashboard'] = 'waterSupply';
      currentUrlParams['dashboardView'] = 'ANDHRAPRADESH'
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['pointClick'] = false;
      currentUrlParams['locationTypeList'] = ['STATE','RIVERGAUGE','RESERVOIR','CITY','MITANK'];
      this.isInitialLoad = false;
    }
    currentUrlParams['source'] = this.selectedSource;
    currentUrlParams['alertType'] = this.selectedAlert;
    this.alertDataSrv.setSelectedParams(currentUrlParams)
  }

onSourceChange() {
    this.selectedParams['source'] = this.selectedSource
    this.selectedParams['actionType'] = 'filter'
    this.setSelectedParams();
  }

}
